import React, { Component } from 'react';
import DataTable from '../../../../components/DataTable/index';
import PropTypes from 'prop-types';
import { FILING_STATUS } from '../../../../services/constant/constant';
import $ from 'jquery';
import { Filings } from '../../services/Filings';

const dateFormatter = new Intl.DateTimeFormat('en-US');

class FilingsByFileByDateListGrid extends Component {
    componentWillUnmount() {
        let { updateSelected } = this.props;
        updateSelected([]);
    }
    render() {
        let { id, dataList, handleEditClick, updateSelected } = this.props;
        return (
            <DataTable
                id={id}
                columns={[
                    {
                        title: '<span class="glyphicon glyphicon-ok" />',
                        data: null,
                        defaultContent: ''
                    },
                    {
                        title: 'Effective<br/>By',
                        data: 'effectiveDate'
                    },
                    {
                        title: 'Expiration',
                        data: 'expirationDate'
                    },
                    {
                        title: 'File By<br/>Date',
                        data: 'fileByDate'
                    },
                    {
                        title: '',
                        data: 'stateCode'
                    },
                    {
                        title: 'Status',
                        data: 'filingStatus'
                    },
                    {
                        title: 'Trust<br/>Name',
                        data: 'trustName'
                    },
                    {
                        title: 'Portfolio<br/>Name',
                        data: 'portfolioName'
                    },
                    {
                        title: 'Class<br/>Name',
                        data: 'className'
                    },
                    {
                        title: 'Filing<br/>Type',
                        data: 'fundFilingType'
                    },
                    {
                        title: 'Sales<br/>Amount',
                        data: 'salesAmount'
                    },
                    {
                        title: 'Net<br/>Amount',
                        data: 'netAmount'
                    },
                    {
                        title: 'State<br/>Fee',
                        data: 'stateFee'
                    },
                    {
                        title: 'Service<br/>Fee',
                        data: 'serviceFee'
                    },
                    {
                        title: 'Other<br/>Fee',
                        data: 'otherFee'
                    },
                    {
                        title: 'Edit',
                        data: null
                    }
                ]}
                data={dataList}
                checkBoxSelection={true}
                pageable
                searchable
                sortable
                onSelectedItems={data => {
                    updateSelected(data);
                }}
                columnFormat={[
                    {
                        targets: [0],
                        orderable: false,
                        className: 'select-checkbox',
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('width', '3%');
                            $(td).css('cursor', 'pointer');
                        }
                    },
                    {
                        targets: [1, 2, 3],
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('width', '5%');
                            $(td).css('text-align', 'center');
                        },
                        render: function(data, type, full) {
                            if (data) {
                                if (type === 'sort') {
                                    return data;
                                } else {
                                    let date = new Date(data);
                                    return dateFormatter.format(date);
                                }
                            }
                        }
                    },
                    {
                        //State Column
                        targets: [4],
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('width', '3%');
                            $(td).css('text-align', 'center');
                        }
                    },
                    {
                        targets: [5],
                        className: 'text-center',
                        render: (data, type, full) => {
                            let filingStatusName = Filings.getFilingStatusName(data);
                            let isSalesReport = full.isSalesReport
                                ? ' (Sales)'
                                : '';
                            return filingStatusName + isSalesReport;
                        }
                    },
                    {
                        targets: [7, 8, 9, 11, 12, 13, 14, 15, 16],
                        orderable: false
                    },
                    {
                        targets: [6],
                        orderData: [6, 7, 8]
                    },
                    {
                        targets: [6, 7, 8, 9],
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('max-width', '110px');
                            td.title = cellData;
                        }
                    },
                    {
                        targets: [8],
                        className: 'text-center',
                        render: (data, type, full) => {
                            switch (data) {
                                case 0:
                                    return 'Unknown';
                                case 1:
                                    return 'Trust';
                                case 2:
                                    return 'Portfolio';
                                case 3:
                                    return 'Class';
                                case 4:
                                    return 'Prospectus';
                                default:
                                    return '';
                            }
                        }
                    },
                    {
                        targets: [9, 10, 11, 12, 13],
                        createdCell: function(td, cellData, rowData, row, col) {
                            $(td).css('width', '5%');
                            $(td).css('text-align', 'right');
                        },
                        render: function(data, type, full) {
                            return (
                                '$' +
                                data
                                    .toFixed(2)
                                    .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                            );
                        }
                    },
                    {
                        targets: [-1],
                        render: function(data, type, full) {
                            return '<span class="label label-default" title="Edit" style="cursor: pointer; font-size: 90%" ><span class="glyphicon glyphicon-search" /></span>';
                        },
                        createdCell: function(td, cellData, rowData, row, col) {
                            let data = cellData;
                            $(td).css('width', '3%');
                            $(td).css('text-align', 'center');
                            $(td).click(cellData => {
                                handleEditClick(data);
                            });
                        }
                    }
                ]}
                rowFormat={(row, data, dataIndex) => {
                    if (data['notes']) {
                        row.title = 'Notes: ' + data['notes'];
                    }
                    if (data.filingStatus === FILING_STATUS.HOLD_FOR_PAYMENT) {
                        $(row).addClass('danger');
                    }
                }}
            />
        );
    }
}

FilingsByFileByDateListGrid.propTypes = {
    id: PropTypes.string,
    dataList: PropTypes.array.isRequired,
    selection: PropTypes.bool
};

FilingsByFileByDateListGrid.defaultProps = {
    selection: false,
    updateSelected: () => {}
};

export default FilingsByFileByDateListGrid;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/SearchFilings/FilingsByFileByDateListGrid.js